import { Provider } from '@angular/core';
import { DataSourceHttpService } from './abstract';
import { DataSourceHttpServiceImpl } from './data-source-http.service';

export const DataSourceHttpProvider: Provider = {
	provide: DataSourceHttpService,
	useClass: DataSourceHttpServiceImpl,
};
